const hours = [
  { days: 'Hafta İçi', time: '09:00 – 21:00' },
  { days: 'Hafta Sonu', time: '10:00 – 22:00' },
];

export default function StoreInfo() {
  return (
    <section id="magaza" className="py-20 md:py-28 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-white/40 text-xs font-bold uppercase tracking-[0.3em] mb-3">Bizi Ziyaret Et</p>
          <h2
            className="text-white uppercase leading-none mb-4"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.5rem, 7vw, 5rem)' }}
          >
            Mağazamıza
            <br />
            <span className="text-[#FF4500]">Bekliyoruz!</span>
          </h2>
          <p className="text-white/50 max-w-md mx-auto text-base">
            Adana'da mağazamıza gel, ürünleri yerinde gör, istediğini anında yaptır.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-start">
          {/* Left – Map */}
          <div className="rounded-2xl overflow-hidden aspect-[4/3] bg-white/5 border border-white/8">
            <iframe
              src="https://maps.google.com/maps?q=Bülent+Angın+Blv.+No+76+Seyhan+Adana+Turkey&output=embed&hl=tr"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Nusret Bulut - Mağaza Konumu"
              className="w-full h-full"
            />
          </div>

          {/* Right – Info Cards */}
          <div className="flex flex-col gap-4">
            {/* Address */}
            <div className="flex items-start gap-4 bg-white/[0.04] border border-white/8 rounded-2xl p-5">
              <div className="w-10 h-10 flex items-center justify-center bg-white/8 border border-white/12 rounded-xl shrink-0">
                <i className="ri-map-pin-2-fill text-white/70 text-lg" />
              </div>
              <div>
                <p className="text-white/40 text-xs uppercase tracking-wide font-semibold mb-1">Adres</p>
                <p className="text-white font-semibold text-sm md:text-base leading-snug">
                  Yenibaraj, Bülent Angın Blv. No:76<br />01140 Seyhan / Adana
                </p>
                <a
                  href="https://share.google/KJgfpw7fowQwPHoFy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#FF4500] text-xs font-semibold mt-2 inline-flex items-center gap-1 hover:underline cursor-pointer"
                >
                  <i className="ri-map-pin-line" />
                  Google Maps'te Aç
                </a>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-center gap-4 bg-white/[0.04] border border-white/8 rounded-2xl p-5">
              <div className="w-10 h-10 flex items-center justify-center bg-white/8 border border-white/12 rounded-xl shrink-0">
                <i className="ri-phone-fill text-white/70 text-lg" />
              </div>
              <div>
                <p className="text-white/40 text-xs uppercase tracking-wide font-semibold mb-1">Telefon</p>
                <a
                  href="tel:+903222286464"
                  className="text-white font-semibold text-sm md:text-base hover:text-[#FF4500] transition-colors cursor-pointer whitespace-nowrap"
                >
                  (0322) 228 64 64
                </a>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="flex items-center gap-4 bg-white/[0.04] border border-white/8 rounded-2xl p-5">
              <div className="w-10 h-10 flex items-center justify-center bg-[#25D366]/15 border border-[#25D366]/25 rounded-xl shrink-0">
                <i className="ri-whatsapp-line text-[#25D366] text-lg" />
              </div>
              <div className="flex-1">
                <p className="text-white/40 text-xs uppercase tracking-wide font-semibold mb-1">WhatsApp</p>
                <a
                  href="https://wa.me/903222286464"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white px-4 py-2 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line w-3 h-3 flex items-center justify-center" />
                  Tıkla, Yaz!
                </a>
              </div>
            </div>

            {/* Hours */}
            <div className="bg-white/[0.04] border border-white/8 rounded-2xl p-5">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/8 border border-white/12 rounded-xl">
                  <i className="ri-time-fill text-white/70 text-lg" />
                </div>
                <p className="text-white/40 text-xs uppercase tracking-wide font-semibold">Çalışma Saatleri</p>
              </div>
              <div className="flex flex-col gap-3">
                {hours.map((h) => (
                  <div key={h.days} className="flex items-center justify-between">
                    <span className="text-white/60 text-sm">{h.days}</span>
                    <span className="text-white font-bold text-sm">{h.time}</span>
                  </div>
                ))}
                <div className="flex items-center gap-2 mt-1">
                  <span className="w-2 h-2 bg-[#25D366] rounded-full animate-pulse inline-block" />
                  <span className="text-[#25D366] text-xs font-semibold">Şu an açık</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
